import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Save, Plus, Trash2, Upload } from "lucide-react";

export default function HeaderBuilder() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/cms/header").then(({ data }) => setData(data || {})); }, []);
  if (!data) return <div className="p-8">Lade...</div>;
  const set = (patch) => setData({ ...data, ...patch });

  const save = async () => {
    setSaving(true);
    try {
      const { id, _id, salon_id, updated_at, ...p } = data;
      await api.put("/cms/header", p);
    } finally { setSaving(false); }
  };

  const upload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    const r = await api.post("/cms/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    set({ logo_url: r.data.url });
  };

  const links = data.menu_links || [];
  const socials = data.socials || [];

  return (
    <div className="p-8 lg:p-12 mv-fade-in max-w-3xl">
      <div className="flex items-end justify-between mb-10">
        <div>
          <p className="mv-label mb-2">Navigation</p>
          <h1 className="font-display text-4xl">Header</h1>
        </div>
        <button data-testid="save-header-btn" onClick={save} disabled={saving} className="mv-btn"><Save className="w-4 h-4" /> {saving ? "..." : "Speichern"}</button>
      </div>

      <div className="mv-card p-6 mb-6">
        <p className="mv-label mb-3">Logo & Kontakt</p>
        <div className="flex gap-3 items-center mb-4">
          {data.logo_url && <img src={data.logo_url} alt="" className="h-10 border rounded" style={{ borderColor: "var(--mv-border)" }} />}
          <label className="mv-btn-ghost text-xs cursor-pointer"><Upload className="w-3 h-3" /> Logo hochladen<input type="file" className="hidden" onChange={upload} /></label>
        </div>
        <label className="block text-xs mb-1">Telefon</label>
        <input className="mv-input mb-3" value={data.phone || ""} onChange={(e) => set({ phone: e.target.value })} />
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs mb-1">CTA-Label</label>
            <input className="mv-input" value={data.cta_label || ""} onChange={(e) => set({ cta_label: e.target.value })} />
          </div>
          <div>
            <label className="block text-xs mb-1">CTA-URL</label>
            <input className="mv-input" value={data.cta_url || ""} onChange={(e) => set({ cta_url: e.target.value })} />
          </div>
        </div>
      </div>

      <div className="mv-card p-6 mb-6">
        <p className="mv-label mb-3">Menü-Links</p>
        {links.map((l, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input className="mv-input flex-1" placeholder="Label" value={l.label} onChange={(e) => { const a = [...links]; a[i] = { ...l, label: e.target.value }; set({ menu_links: a }); }} />
            <input className="mv-input flex-1" placeholder="URL" value={l.url} onChange={(e) => { const a = [...links]; a[i] = { ...l, url: e.target.value }; set({ menu_links: a }); }} />
            <button onClick={() => set({ menu_links: links.filter((_, j) => j !== i) })} className="p-2"><Trash2 className="w-4 h-4 text-red-500" /></button>
          </div>
        ))}
        <button data-testid="add-menu-link" onClick={() => set({ menu_links: [...links, { label: "", url: "" }] })} className="mv-btn-ghost text-xs"><Plus className="w-3 h-3" /> Hinzufügen</button>
      </div>

      <div className="mv-card p-6">
        <p className="mv-label mb-3">Social Media</p>
        {socials.map((s, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input className="mv-input w-32" placeholder="Plattform" value={s.platform} onChange={(e) => { const a = [...socials]; a[i] = { ...s, platform: e.target.value }; set({ socials: a }); }} />
            <input className="mv-input flex-1" placeholder="URL" value={s.url} onChange={(e) => { const a = [...socials]; a[i] = { ...s, url: e.target.value }; set({ socials: a }); }} />
            <button onClick={() => set({ socials: socials.filter((_, j) => j !== i) })} className="p-2"><Trash2 className="w-4 h-4 text-red-500" /></button>
          </div>
        ))}
        <button onClick={() => set({ socials: [...socials, { platform: "", url: "" }] })} className="mv-btn-ghost text-xs"><Plus className="w-3 h-3" /> Hinzufügen</button>
      </div>
    </div>
  );
}
